import styled, { css } from "styled-components";
const StyledLink = styled.a(({
  theme: {
    passive,
    hover,
    size,
    fontSize,
    type
  }
}) => css`
    display: inline;
    cursor: pointer;
    transition: 0.2s;
    text-decoration: none;
    width: fit-content;
    font-size: ${fontSize};
    border-width: 0;
    border-bottom-width: 1px;

    color: ${passive.color};
    border-bottom-color: ${passive.border};

    :hover {
      color: ${hover.color};
      border-bottom-color: ${hover.border};
    }

    ${type === "underline" && css`
      border-style: solid;
    `};

    ${type === "pseudo" && css`
      border-style: dashed;
    `};

    ${size === "small" && css`
      font-style: italic;
      line-height: 15px;

      :hover {
        border-color: transparent;
      }
    `}
  `);
export default StyledLink;